import { Injectable } from '@angular/core';
import { ApiService } from '@nrwl/common-lib';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ControllerApiService {
  private _serverConfig = null;

  private queryTestConfig = '/uicomm/GetConfiguration';
  private queryControllerConfig = '/uicomm/getServerConfig';
  private saveEndpoint = '/uicomm/saveEndpointData';
  private getEndpoint = '/uicomm/findEndpointData';
  private getJmepConfig = '/uicomm/getJMEPConfig';
  private setJmepConfig = '/uicomm/setJMEPConfig';
  private getLicenseAPI = '/uicomm/getLicense';
  private getSoftwareVersionPath = '/uicomm/softwareVersion';
  private getTestListAPI = '/uicomm/getTestList';
  constructor(private readonly apiService: ApiService) {}

  //eslint-disable-next-line
  getTestConfig(id: number, isPublic = false): Observable<any> {
    const url = isPublic ? `/assurance/etherx/public${this.queryTestConfig}` : this.queryTestConfig;
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.post$<any>(url, { scheduleId: id });
  }

  //eslint-disable-next-line
  getServerConfig(): any {
    const url = `${this.queryControllerConfig}`;
    return this.apiService.post$<any>(url);
  }

  //eslint-disable-next-line
  findEndpointData(name): any {
    const url = `${this.getEndpoint}/${name}`;
    return this.apiService.post$<any>(url, {});
  }

  //eslint-disable-next-line
  saveEndpointData(data): any {
    const url = `${this.saveEndpoint}`;
    return this.apiService.post$<any>(url, data);
  }

  //eslint-disable-next-line
  getJMEPConfig(config): any {
    const url = `${this.getJmepConfig}`;
    return this.apiService.post$<any>(url, config);
  }

  //eslint-disable-next-line
  setJMEPConfig(config): any {
    const url = `${this.setJmepConfig}`;
    return this.apiService.post$<any>(url, config);
  }

  //eslint-disable-next-line
  getLicense(): any {
    const url = `${this.getLicenseAPI}`;
    return this.apiService.post$<any>(url, {});
  }

  getSoftwareVersion(): any {
    return this.apiService.post$<any>(this.getSoftwareVersionPath, {});
  }

  //eslint-disable-next-line
  getTestList(config): any {
    const url = `${this.getTestListAPI}`;
    return this.apiService.post$<any>(url, config);
  }

  //eslint-disable-next-line
  set serverConfig(serverConfig: any) {
    this._serverConfig = serverConfig;
  }

  get serverConfig(): any {
    return this._serverConfig;
  }
}
